module.exports = "/virtual-football-league/img/jerseys/Green.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/jerseys/Green.png
// module id = 2240
// module chunks = 4